import type { ResolverMap } from './ResolverMap'
import type { ClosureCode } from '~/services/api/generated'

const closureByCode = {
  STORE_TEMPORARILY_CLOSED: 'presentation.closure.temporarilyClosedUntil',
  STORE_CLOSURE_UPCOMING: 'presentation.closure.closureUpcoming'
} satisfies Record<ClosureCode, string>

export const closureResolverMap: ResolverMap<ClosureCode> = {
  byCode: closureByCode,
  byReason: {},
  genericKey: 'presentation.closure.temporarilyClosedGeneric'
}
